export default "__VITE_ASSET__vh846L05__"